export default {
  background_image: 'Image de fond',
  file_too_large: 'Le fichier est trop volumineux. La taille maximale est de {{max}} Mo.',
  upload_failed: 'Échec du téléversement. Veuillez réessayer.',
};
